import {
  ApiPostNoToken, ApiPostWithLoginToken
} from 'shared/api'
import {
  authApi
} from 'interface/endpoints'
import {
  LoginFormData, LoginResult,
  ChangePasswordFormData, 
  GroupLoginFormData, GroupLoginResult
} from './types'

export * from './types'

export const DoLogin = async (
  domain: string,
  form: LoginFormData
) => ApiPostNoToken<LoginResult>(
  authApi(`/login/${domain}`),
  form
)

export const DoLogoff = (
  loginToken: string
) => ApiPostWithLoginToken<null>(
  loginToken,
  authApi('/logoff')
)

export const ChangePassword = async (
  loginToken: string,
  form: ChangePasswordFormData
) => ApiPostWithLoginToken<void>(
  loginToken,
  authApi('/changePassword'),
  form
)

export const DoGroupLogin = (
  loginToken: string,
  form: GroupLoginFormData
) => ApiPostWithLoginToken<GroupLoginResult>(
  loginToken,
  authApi('/group'),
  form
)
